import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet';
import '../css/Placement.css';

const Placement = () => {
  const students = [
  {
    title: "Accountant - DEVI PRASAD PATEL",
    desc: "Ajeet Enterprises, Damoh",
    image: "1.jpg",
  },
  {
    title: "Accountant - RUBAL JAIN",
    desc: "Shree Enterprises, Damoh",
    image: "2.jpg",
  },
  {
    title: "Accountant - CHIRAG RAJAK",
    desc: "Abhay Computer, Honey sales, Damoh",
    image: "3.jpg",
  },
  {
    title: "Accountant - MAYANK JAIN",
    desc: "Damoh Battery Service,Damoh",
    image: "4.jpg",
  },
  {
    title: "Accountant - GURNEESH SINGH BAGGA",
    desc: "Vidhya Sagar Logistics, Damoh",
    image: "5.jpg",
  },
  {
    title: "Accountant - JITENDRA PATEL",
    desc: " Smart homes, Damoh",
    image: "6.jpg",
  },
  {
    title: "Accountant - SUBODH RAJAK",
    desc: "BALAJI MARKETING, Damoh",
    image: "7.jpg",
  },
  {
    title: "Accountant - AMAN ASATI",
    desc: "Texol company, Damoh",
    image: "8.jpg",
  },
  {
    title: "Accountant - VIKASH AHIRWAL",
    desc: "Nirman, Damoh",
    image: "9.jpg",
  },
  {
    title: "Accountant - SURYANSH SINGHAI",
    desc: "Upkar Traders, Damoh",
    image: "10.jpg",
  },
];

  return (
    <>
    <Helmet>
      <title>Placement | Shrikant Tally Institute – 80% Job Placement Rate in Damoh</title>
      <meta name="description" content="Shrikant Tally Institute offers guaranteed placement assistance for Tally-certified students in Damoh. 80% placement rate, 554+ employer network, internships, campus drives & job fairs." />
      <meta name="keywords" content="Tally placement Damoh, accounting job placement MP, Tally certified job, Shrikant Tally placement, accounting career Damoh, Tally internship Damoh, job after Tally course, finance job Madhya Pradesh, Tally Education placement, accountant job Damoh" />
      <meta property="og:title" content="Placement | Shrikant Tally Institute – Damoh" />
      <meta property="og:description" content="80% placement rate with 554+ employer network. Get placed after Tally certification at Shrikant Tally Institute, Damoh." />
      <meta property="og:url" content="https://shrikanttallyinstitute.com/placement" />
      <meta property="og:type" content="website" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://shrikanttallyinstitute.com/placement" />
    </Helmet>
    <div
      className="container-fluid bannerContainer  "
      style={{
        backgroundImage: `url('https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/background-blue-pattern.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '500px',
      }}
    >
      
      <div className="container h-100">
        <div className="row align-items-center h-100">
          <div className="col-md-5 position-relative order-1 order-md-2">
            <img
              src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/placements-banner-new.jpg"
              className="w-100 rounded-3 position-relative position-md-absolute placemet-all-page-hero-img"
              alt="Career with Tally"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
          <div className="col-md-7 placemet-content-section-hero order-2 order-md-1 text-center text-md-start">
            <h3 className="banner-title-heading mb-4">
              Level Up Your Career With Tally Education!
            </h3>
            <p className="banner-sub-heading-2 mb-3  fs-md-5 fw-bold" style={{color:"#648493"}}>
              Get Certified and take a step toward your desired job! Tally Education supports you
              throughout your journey from Certification to Placement.
            </p>
          </div>
        </div>
      </div>
    </div>    
    <div className="container-fluid rounded text-center"       style={{
        backgroundImage: `url('https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/background-blue-pattern.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',

      }}>
      <h3 className=" fw-bold p-3" style={{color:'#90b732'}}>An accomplished spirit takes confident flight into successful placement.</h3>
      <div className=" align-items-center  text-center">
        <h6 className="text-center"  style={{color:"#648493"}}>Explore success stories and join us on the path to financial expertise.</h6>
       
      </div>

<div className="d-flex overflow-hidden py-5 px-2 position-relative rounded text-center">
  <div className="marquee-scroll d-flex">
    {[...students, ...students].map((stu, i) => (
      <div
        className="card mx-3 shadow d-flex flex-column align-items-center text-center"
        style={{
          minWidth: "18rem",
          maxWidth: "20rem",
          flex: "0 0 auto",
          border: "none",
          borderRadius: "20px",
          padding: "1.2rem",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
        key={i}
      >
        {/* Image */}
        <img
          src={`${process.env.PUBLIC_URL}/${stu.image}`}
          alt={stu.title}
          style={{
            height: "180px",
            width: "180px",
            objectFit: "cover",
            borderRadius: "12px",
            marginBottom: "1rem",
            border: "2px solid #ccc",
          }}
        />

        {/* Title */}
        <h6
          className="card-title mb-1 fs-6 fw-semibold text-uppercase mt-2"
          style={{ color: "#90b732", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {stu.title}
        </h6>

        {/* Description */}
        <p
          className="card-text text-muted"
          style={{ fontSize: "14px", textAlign: "center", lineHeight: "1.4em" }}
        >
          {stu.desc}
        </p>
      </div>
    ))}
  </div>
</div>


      </div>
        <section className="light-telly get-placed" style={{ padding: '60px 0' }}>
      <div className="container">
        <div className="get-placed-title-area text-center mx-auto mb-5">
          <div>
            <div className="title heading2 mb-4 mt-5" style={{ fontSize: '2rem', fontWeight: 'bold' }}>
              How We Facilitate Your Placement
            </div>
            <div className="text2 text-grey" style={{ color: '#6c757d', fontSize: '1rem' }}>
              Elevate your career prospects with our placement assistance for all Tally-certified
              learners, ensuring a seamless transition from learning to successful employment in the
              world of finance and accounting.
            </div>
          </div>
        </div>

        <div className="get-placed-content">
          <div className="row">
            {/* Internships */}
            <div className="col-md-6 mb-4">
              <div className="online-internships get-placed-content-height p-3 shadow rounded" style={{ height: '250px',background:'#ecf3d7' }}>
                <img
                  src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/online-internships-placement.png"
                  alt="Online Internships"
                  className="mb-3"
                  style={{ maxHeight: '60px' }}
                />
                <h5 className="heading5 mb-3">Internships</h5>
                <p className="text2" style={{ fontSize: '0.95rem'}}>
                  We provide opportunities to gain practical experience and develop essential skills with internships.
                  Build your professional network and enhance your career prospects.
                </p>
              </div>
            </div>

            {/* Campus Drives */}
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="campus-drives get-placed-content-height p-3 shadow rounded" style={{ height: '250px',background:'#fffbe5' }}>
                <img
                  src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/campus-drives-job-fair.png"
                  alt="Campus Drives and Job Fair"
                  className="mb-3"
                  style={{ maxHeight: '60px' }}
                />
                <h5 className="heading5 mb-3">Campus Drives* and Job Fairs</h5>
                <p className="text2" style={{ fontSize: '0.95rem' }}>
                  We bridge the gap between talent and opportunity. Our initiatives, designed for Tally-certified learners,
                  provide a platform where industry leaders actively seek top-notch professionals.
                </p>
                <span style={{ fontSize: '10px' }}>*Terms and Conditions Apply</span>
              </div>
            </div>

            {/* Industry Connect */}
            <div className="col-md-6 mb-4">
              <div className="placement-drives get-placed-content-height p-3 shadow rounded" style={{ height: '250px',background:'#fffbe5' }}>
                <img
                  src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/placement-drives.png"
                  alt="Placement Drives"
                  className="mb-3"
                  style={{ maxHeight: '60px' }}
                />
                <h5 className="heading5 mb-3">Industry Connect</h5>
                <p className="text2" style={{ fontSize: '0.95rem' }}>
                  We help you enter the workforce with confidence. Our Industry Connect events offer Tally-certified learners
                  practical exposure, industry insights, and networking opportunities.
                </p>
              </div>
            </div>

            {/* Placement Events */}
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="placement-webinars get-placed-content-height p-3 shadow rounded" style={{ height: '250px',background:'#ecf3d7' }}>
                <img
                  src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/placement-webinars.png"
                  alt="Placement Webinars"
                  className="mb-3"
                  style={{ maxHeight: '60px' }}
                />
                <h5 className="heading5 mb-3">Placement Events</h5>
                <p className="text2" style={{ fontSize: '0.95rem' }}>
                  Our placement events like webinars and workshops enhance job readiness by providing Tally-certified learners
                  with essential skills, industry insights, and personalized feedback to succeed in their careers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
        <section className="bg-white employer-count mb-5">
      <div className="d-flex container justify-content-between flex-wrap flex-md-nowrap">
        {/* Content Section */}
        <div className="d-flex align-items-center justify-content-center">
          <div className="employer-count-content">
            <h4 className="title-heading-1 mb-4 mb-lg-5 fw-bold">How Do We Make A Difference</h4>

            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="employer-count-card">
                  <div className="employer-count-card-number heading2 primary-telly">
                    <span id="total_employers" className="fw-bold fs-4"style={{color:"#90b732"}}>554+</span>
                  </div>
                  <div className="employer-count-card-title heading5 text-grey fw-bold">Network of Employers</div>
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <div className="employer-count-card">
                  <div className="employer-count-card-number heading2 primary-telly">
                    <span id="total_vacancies" className="fw-bold fs-4"style={{color:"#90b732"}}>168+</span>
                  </div>
                  <div className="employer-count-card-title heading5 text-grey fw-bold">Job Posted</div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="employer-count-card mb-0">
                  <div className="employer-count-card-number heading2 primary-telly">
                    <span id="active_vacancies" className="fw-bold fs-4"style={{color:"#90b732"}}>2560+</span>
                  </div>
                  <div className="employer-count-card-title heading5 text-grey fw-bold">Active Jobs</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Image Section */}
        <div className="justify-content-end d-flex">
          {/* Desktop Image */}
          <img
            src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/employer2.jpg"
            alt="Tally Jobs"
            className="d-none d-md-block"
            style={{ borderRadius: '20px', width: '700px' }}
          />
          {/* Mobile Image */}
          <img
            src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/employer2.jpg"
            alt="Tally Jobs"
            className="w-100 d-md-none p-3"
            style={{ borderRadius: '20px', width: '700px' }}
          />
        </div>
      </div>
    </section>
    </>
  );
};

export default Placement;
